/*
 * @Date: 2021-01-27 14:20:36
 * @Author: lvjun
 * @Description: 接口管理
 */
import { post, get } from '@public/http/request'

import { APICUS } from '@public/utils/const'
import { GATEWAYSER } from '@/common/config/index'
import { BASE_URL } from '@public/http/config'

//登录
export const login = (params) => post(`${APICUS}/auth/login`, params) // 登录
export const logout = () => post(`${APICUS}/auth/logout`) // 退出
export const register = (params) => post(`${APICUS}/user/register`, params) // 注册
export const getImgCode = (params) => get(`${APICUS}/captcha/getCaptcha`, params) // 获取图形验证码
export const resetPassword = (params) => post(`${APICUS}/auth/reset/resetPwd`,params) // 重置密码
export const checkCaptcha = (params) => post(`${APICUS}/sms/checkCaptcha`,params) // 验证图形验证码-获取短信验证码
export const modifyPassword = (params) => post(`${APICUS}/auth/changePwd`, params) // 修改密码
export const getUserInfo = (params) => get(`${APICUS}/auth/getStaffUserInfo`, params)  // 获取个人信息
export const verifyPhone = (params) => post(`${APICUS}/auth/reset/checkInfoAndSendSms`, params)  // 判断手机号是否已注册
export const loginSms = (params) => get(`${APICUS}/auth/loginSms`, params)  // 首次登录手机号验证


//查询站点下拉框List
export const getReceiveStationCodeList = (params) => post(`${APICUS}/station/select`,params)

//获取二级菜单和按钮
export const getuserChildMenus = (params) => get(`${APICUS}/stationRole/userChildMenus`,params)

//查询站点详情
export const queryStationInfo = (params) => post(`${APICUS}/station/queryStationInfo`,params)
//编辑站点设置信息
export const editStationSetInfo = (params) => post(`${APICUS}/stationSiteSetup/editStationSetInfo`,params)

//获取快递品牌
export const getWpBasicInfo = (params) => get(`${APICUS}/tab-station-scan/getWpBasicInfo`,params)

// 修改投诉人电话(客服电话)
export const modifyComplaintMobile = (params) => get(`${APICUS}/station/modifyComplaintMobile`,params).then(res=>res)
// 获取外部用户信息
export const getOutUserByCode = () => get(`/bpo/opUser/getOutUserByCode`, {}, { headers: { routeName: 'opUser' } })

/* 公共接口部分 开始 */
// 获取省市区
export const getAreaByCode = (params) => post(`${APICUS}/stationArea/getAreaByCode
`,params)
// 上传图片
// export const UPLOADUMG = `${BASE_URL}${APICUS}/file/uploadImg`
// 获取正常图片地址
export const getImgUrl = (params) => get(`${APICUS}/file/getImgUrl`,params)
// 获取水印图片地址 - 身份证
export const getWaterMarkImgUrl = (params) => post(`${APICUS}/file/getWaterMarkImg`,params)
/* 公共接口部分 结束 */

/**
 * 站点管理——入驻申请
 */
export const stationInfo = {
  // 入驻申请表单提交
  addStationInfo(params) {
    return post(`${APICUS}/station/addStationInfo`, params).then(res => res)
  },
  editStationInfo(params) {
    return post(`${APICUS}/station/editStationInfo`, params).then(res => res)
  },
  // 查询审核状态
  queryStationInfo(params) {
    return post(`${APICUS}/station/queryStationInfo`, params).then(res => res)
  }
}

/**
 * 运营管理——公告
 */
export const stationNotice = {
    reqList(reqData) {
      return post(`${APICUS}/stationNotice/page`,reqData).then(res => res)
    },
    reqAdd(reqData) {
        return post(`${APICUS}/stationNotice/save`, reqData).then(res => res)
    },
}
/**
 * 运营管理——客户管理
 */
export const customerManagement = {
    reqList(reqData) {
      return post(`${APICUS}/tab-dif-customer/page`,reqData).then(res => res)
    },
    reqAdd(reqData) {
        return post(`${APICUS}/tab-dif-customer/add`, reqData).then(res => res)
    },
    reqUpdate(reqData) {
        return post(`${APICUS}/tab-dif-customer/update`, reqData).then(res => res)
    },
}

/**
 * 包裹管理——库存
 */
export const store = {
    reqList(reqData) {
      return post(`${APICUS}/tab-station-scan/page`,reqData).then(res => res)
    }
}
//库存详情
export const getTabScanDetail = (id,stationCode) => get(`${APICUS}/tab-station-scan/detail?waybillCode=${id}&stationCode=${stationCode}`).then(res => res)


/**
 * 站点管理——员工管理
 */
export const staffManage = {
    reqList(reqData) {
        return post(`${APICUS}/staff/queryStaffPage`,reqData).then(res => res)
    },
    reqAdd(reqData) {
        return post(`${APICUS}/staff/addStaffInfo`, reqData).then(res => res)
    },
    reqUpdate(reqData) {
        return post(`${APICUS}/staff/editStaffInfo`, reqData).then(res => res)
    },
    reqDel(reqData) {
        return get(`${APICUS}/staff/delStaffInfo?id=${reqData.id}`).then(res => res)
    },

}

/**
 * 短信管理——短信记录
 */
export const smsRecord = {
    reqList(reqData) {
        return post(`${APICUS}/sms/page`, reqData).then(res => res)
    },
}
export const smsTemplate = {
    reqList(reqData) {
        return post(`${APICUS}/smsTemplate/page`, reqData).then(res => res)
    },
}

/**
 * 用户权限——用户管理
 */
export const userManage = {
    reqList(reqData) {
        return post(`${APICUS}/stationUser/list`, reqData).then(res => res)
    },
    userEnable(params) { // 启用禁用
        return get(`${APICUS}/stationUser/userEnable`, params).then(res => res)
    },
    userAuth(params) {  // 用户授权
        return get(`${APICUS}/stationUser/userAuth`, params).then(res => res)
    },
    statusCheck(params) { // 用户审核
        return get(`${APICUS}/stationUser/statusCheck`, params).then(res => res)
    },
}
/**
 * 用户权限——权限设置
 */
export const roleManage = {
    reqList(reqData) {
        return post(`${APICUS}/stationRole/roleList`, reqData).then(res => res)
    },
    roleDetail(params) { // 权限设置
        return get(`${APICUS}/stationRole/userRoleMenusAll`, params).then(res => res)
    }
}



/**
 * 首页——汇总
 */
export const dataSummary = {
    reqSummary(reqData) {
        return post(`${APICUS}/stationStatistics/linchpin`,reqData).then(res => res)
    },
    reqBarChart (reqData) {
        return post(`${APICUS}/stationStatistics/stockBarChart`,reqData).then(res => res)
    }
}

/**
 * 短信管理-资金账户
 */
export const Recharge = {
    getWallet(params) {
        return get(`${APICUS}/station/wallet`, { params }).then(res => res)
    },
    getOrder (params) {
        return get(`${APICUS}/station/recharge/order`,params).then(res => res)
    },
    getResult (params) {
        return get(`${APICUS}/station/recharge/result`,params).then(res => res)
    }
}
